module.exports = __webpack_public_path__ + "static/media/3DPPA11.53122a7c.jpg";